export enum TipoPromocaoEnum {
	MUDANCA_CARGO = 0,
    AUMENTO_NIVEL_CARGO = 1,
    AUMENTO_SALARIAL = 2,
}
